import styled from '@emotion/styled';

export const AppContainer = styled.div<{ isLoginPage?: boolean }>`
  min-height: 100vh;
  background: #f3f6fb;
  display: flex;
  flex-direction: column;
  align-items: center;

  /* паддинг ТОЛЬКО на внутренних страницах */
  padding: ${({ isLoginPage }) => (isLoginPage ? '0' : '32px 8px')};

  @media (max-width: 600px) {
    padding: ${({ isLoginPage }) => (isLoginPage ? '0' : '16px 2px')};
  }
`;

// принимаем проп `isLoginPage`
export const ContentWrapper = styled.div<{ isLoginPage?: boolean; isDesktop?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;

  ${({ isLoginPage, isDesktop }) =>
    !isLoginPage &&
    `
      max-width: ${isDesktop ? '1250px' : '420px'};
    `}
`;
